import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertsService } from 'app/ui-components/alerts/alerts.service';
import { AdminService } from 'app/services/admin.service';
import { MockManageLicensesData } from 'app/models/data/mock/admin';
import { LicenseData } from 'app/models/admin.model';
import { ResultResponse } from 'app/models/common.model';
import { SharedDataService } from 'app/services/sharedData.service';
import { UserService } from 'app/users/user.service';
import { CustomerService } from 'app/services/customer.service';
import { ProductName } from 'app/models/products.model';
import { AuthService, Passport } from 'app/services/auth.service';
import * as uuid from 'uuid';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-manage-licenses',
  templateUrl: './manage-licenses.component.html',
  styleUrls: ['../admin-common.scss']
})

export class ManageLicensesComponent implements OnInit {

  @ViewChild(MatTable) table! : MatTable<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('addLicenseeDialog') addLicenseeDialog!: TemplateRef<any>;

  introMessage!: string;
  productList: string[] = [];
  selectedProduct!: string;
  columnsToDisplay: string[] = ['fName', 'lName','email', 'admin', 'action'];
  dataSource = new MatTableDataSource<any>();
 
  selRow!: number;
  licenseForm!: FormGroup;
  licenseDataList: LicenseData[] = [];
  initialDataList: any;
  needsUpdate: boolean = false;

  addLicenseForm!: FormGroup;
  addLicenseeDialogRef!: MatDialogRef<any, any>;
  initialAddFormValues: any;
  msgText!: string;
  email: any;
  emailForAdd: any;
  agreementId: string = "";
  loaded: boolean = false;

  constructor(
    private alertService: AlertsService,
    private formBuilder: FormBuilder,
    private adminService: AdminService,
    private sharedDataService: SharedDataService, 
    private changeDetectorRefs: ChangeDetectorRef,
    private userService: UserService,
    private customerService: CustomerService,
    private authService: AuthService,
    private dialog: MatDialog
  ) {}

  ngAfterViewInit() {
    setTimeout(() => {
      this.dataSource.paginator = this.paginator;
    }, 1000);    
  }

  ngOnInit() {
    let token: Passport  = {
      id: uuid.v4(),
      userFlow: 'admin'
    }
    if(typeof this.userService.profile !== "undefined") {
      token['customerNumber'] = this.userService.profile.customerNumber;
    } else {
      token['customerNumber'] = '';
    }
      this.authService.getToken(token)
         .pipe(
          finalize(() => {
            this.retrieveDetails();
            //this.changeDetectorRefs.detectChanges();
          }
        )
      )
       .subscribe();
  
  }
  linkData() {
    this.initializeForm();
    this.dataSource = new MatTableDataSource((this.licenseList as FormArray).controls);
    this.loaded = true;
  } 

  retrieveDetails() {
    this.introMessage = MockManageLicensesData.introMessage;
    this.sharedDataService.getSubscriptions.subscribe( data => { 
              if(data === null) {
                    const prods = [Object.keys(ProductName)[0]];
                    this.customerService.fetchSubscriptions(this.userService.profile.customerNumber, prods).subscribe({
                      next: (res) => {
                        if (res.Data !== null) {       
                          const subscriptions = res.Data.filter( (d) => d.Status.Name === "Active");
                          this.sharedDataService.setSubscriptions(res.Data) 
                          for (const sub of subscriptions) {
                            this.agreementId = sub.AgreementId;
                            if (this.productList.indexOf(sub.Components[0].ProductName) === -1) {      
                              this.productList.push(sub.Components[0].ProductName);          
                            }
                            for (const person of sub.Participants) {
                              if (person.AccessType !== "Administrator" && !this.userExists(person.Email)) {
                              //if (!this.userExists(person.Email)) {
                                const name:string[] = person.FullName.split(" ");
                                const lastName = name.length > 2 ? name[2] : name[1];
                                let participant: LicenseData = {
                                email: person.Email,
                                firstName: name[0],
                                lastName: lastName,
                                customerNumber: person.CustomerNumber,
                                agreementId: sub.AgreementId,
                                accessType: person.AccessType
                                }
                                this.licenseDataList.push(participant);
                              }                               
                            }
                            this.customerService.getInvitedUsers(sub.AgreementId, "lic").subscribe({
                              next: (resInv) => {
                                if (resInv.Data !== null) {
                                  for(const  inv of resInv.Data) {
                                    if (!this.userWithIdExists(inv.Id) && inv.Access !== "Administrator") {
                                      let participant: LicenseData = {
                                      email: inv.EmailAddress,
                                      firstName: inv.FirstName,
                                      lastName: inv.LastName,
                                      customerNumber: "",
                                      id: inv.Id,
                                      agreementId: sub.AgreementId,
                                      accessType: inv.Access
                                      }
                                      this.licenseDataList.push(participant);
                                    }                  
                                  }  
                                }
                                this.linkData();  
                              },
                              error: (err) => {console.log(err.message);
                                this.linkData();
                              }
                            });                              
                          }                           
                        }
                      },
                      error: (err) => { 
                        console.log(err); 
                      }              
                    }); 
      } else {     
        const subscriptions = data.filter( (d) => d.Status.Name === "Active");      
        for (const sub of subscriptions) {    
            this.agreementId = sub.AgreementId;
            if (this.productList.indexOf(sub.Components[0].ProductName) === -1) {      
              this.productList.push(sub.Components[0].ProductName);          
            }
            for (const person of sub.Participants) {
              if (person.AccessType !== "Administrator" && !this.userExists(person.Email)) {
              //if (!this.userExists(person.Email)) {
                const name:string[] = person.FullName.split(" ");
                const lastName = name.length > 2 ? name[2] : name[1];
                let participant: LicenseData = {
                email: person.Email,
                firstName: name[0],
                lastName: lastName,
                customerNumber: person.CustomerNumber,
                agreementId: sub.AgreementId,
                accessType: person.AccessType
              }
                this.licenseDataList.push(participant);
              }
            }
            this.customerService.getInvitedUsers(sub.AgreementId, "lic").subscribe({
              next: (resInv) => {
                if (resInv.Data !== null) {
                  for(const  inv of resInv.Data) {
                    if (!this.userWithIdExists(inv.Id) && inv.Access !== "Administrator") {
                      let participant: LicenseData = {
                      email: inv.EmailAddress,
                      firstName: inv.FirstName,
                      lastName: inv.LastName,
                      customerNumber: "",
                      id: inv.Id,
                      agreementId: sub.AgreementId,
                      accessType: inv.Access
                      }
                      this.licenseDataList.push(participant);
                    }                  
                  }  
                }
                this.linkData();  
              },
              error: (err) => {console.log(err.message);
                this.linkData();
              }
            });              
          }
        }  
      }            
    );   
  }

  retrieveLicenseData(prodId: string) {
    this.adminService.getManageLicensesData(prodId).subscribe({
      next: (data: LicenseData[]) => {
        this.licenseDataList = data;
        //refresh data
        this.refreshLicenseForm(data)
        this.dataSource = new MatTableDataSource((this.licenseList as FormArray).controls);
      }, 
      error: err => {
          this.alertService.displayError("Error occured retrieving products");
      } 
    });
  }

  initializeForm() {
    this.licenseForm = this.formBuilder.group({
      licenseList : this.formBuilder.array(this.licenseDataList.map(
        lic => this.formBuilder.group({
          //licenseId: new FormControl(lic.licenseId),
          firstName: [ lic.firstName, Validators.required],
          lastName:[ lic.lastName, Validators.required],
          email:[ lic.email, [Validators.required, Validators.email]],
          accessType:[ lic.accessType ],
          selected: [ false, ''] 
        })            
      ))
    });   
    this.initialDataList = Object.assign({}, this.licenseList.value);
  }

  get licenseList() {
    return this.licenseForm.get('licenseList') as FormArray;
  }

  getRow(indx: any) {
    return indx + this.paginator.pageIndex * this.paginator.pageSize;
  }

  deleteLicense(row: any, product: string) {
    
    let indx = this.getRow(row);
    //let index = row; 
    /*this.licenseList.value.forEach(element => {
      console.log('Before full' +JSON.stringify(element))
    }); */
    //console.log('To be deleted row '+ indx  +JSON.stringify(this.licenseList.value[indx]))
    const email: string = this.licenseList.at(indx).get('email')?.value;
    const ids: number[] = this.getDeletedIds(email);
    const remaining = this.licenseDataList.filter( data => data.email !== email);
    this.adminService.deleteLicenseData(remaining, ids).subscribe({
      next: (res: ResultResponse)=> {
        if(res.Data && JSON.parse(res.Data).Data === "Success") {
          this.alertService.displaySuccess("Successfully removed participant");
          let delObj = Object.assign({}, this.licenseList.value[indx]);
          delete delObj.selected; //remove the selected element from the object as its not needed for the delete call
          //Update the display
          this.licenseList.removeAt(indx);
          this.dataSource = new MatTableDataSource((this.licenseList as FormArray).controls);
          //this.changeDetectorRefs.detectChanges();
          this.sharedDataService.setSubscriptions(null);
          this.dataSource.paginator = this.paginator;      
        } else
          this.alertService.displayError("Error occured while deleting license");
      }, error: err => {
        this.alertService.displayError("Error occured while deleting license");
      } 
    });
    
  }

  saveEdit(row: any, product: string) {
    let indx = this.getRow(row);
    this.email = this.licenseList.at(indx).get('email');
    let userExists = this.checkForDuplicateEmail(this.email);
    if(!this.hasInvalidData(indx, userExists)) {
      let updatedFields: any = {};
      this.findUpdatedFields(this.licenseList.value[indx], updatedFields, this.initialDataList[indx], false);
      if(this.needsUpdate) {
        updatedFields['licenseId'] = row+1;
        let requestBody : Partial<LicenseData> = {};
        Object.assign(requestBody, updatedFields)
        //console.log('To be updated ' +JSON.stringify(requestBody))
        //call update license data to update this record
        /*this.adminService.updateLicenseData(requestBody, this.selectedProduct).subscribe({
          next: (data: ResultResponse)=> {
            if(data && data.success) {
              this.alertService.displaySuccess(data.message);
            } else
              this.alertService.displayError("Error occured while updating license");

          }, error: err => {
            this.alertService.displayError("Error occured while updating license");
          } 
        }); 
        
        this.retrieveLicenseData(product);
        
        */
      }
      this.licenseList.at(indx).get('selected')?.setValue(false);
    }
  }

  checkForDuplicateEmail(control: AbstractControl): boolean {
    let exists = false;
    this.licenseList.value.forEach(element => {
      if(!element.selected) {
        if(element.email === control?.value) { 
          setTimeout(() => control?.setErrors({'alreadyExists': true}) );
          exists = true;
          return exists;
        }
      }
      return exists;
    });
    return exists;
  }

  hasInvalidData(row: any, userExists: boolean) {
    if(userExists)
      return true;
    if(!this.licenseList.controls[row].valid)
      return true;
    if(!this.licenseList.controls[row].touched && this.licenseList.controls[row].pristine)
      return true;
    return false;
  }

  cancel(row: any) {
    let index = this.getRow(row);
    let updatedFields: any = {};
    this.findUpdatedFields(this.licenseList.value[index], updatedFields, this.initialDataList[index], false);
    if(this.needsUpdate) {
      //iterate and reset the specific fields
      Object.keys(updatedFields).forEach(fld => {
        this.licenseList.at(index).get(fld)?.setValue(this.initialDataList[index][fld])
      }) 
    }
    this.licenseList.at(index).get('selected')?.setValue(false);
  }

  findUpdatedFields(formGroup : FormGroup, updatedFields:any, initialFormValues: any, forAdd: boolean) {
    this.needsUpdate = false;
    let fGroup = !forAdd? formGroup : formGroup.controls;
     Object.keys(fGroup).forEach(key => {
      if(key != 'selected') {//} && key != 'licenseId') {
        let formElement = !forAdd? formGroup[key] : formGroup.controls[key].value;
        if(initialFormValues[key] != formElement) {
          updatedFields[key]= formElement;
          this.needsUpdate = true; 
        }
      }
    });
  }

  addLicensee(product: string) {
    this.initializeAddForm();
    this.addLicenseeDialogRef = this.dialog.open(this.addLicenseeDialog, {
      width: '350px',
      height: '555px',
    });
    this.initialAddFormValues = Object.assign({}, this.addLicenseForm.value);
    this.selectedProduct = product;
  }

  initializeAddForm() : void {
    this.addLicenseForm = this.formBuilder.group({
      firstName: [ '', Validators.required],
      lastName:[ '', Validators.required],
      email:[ '', [Validators.required, Validators.email]],
      selected:[false,'']
    });
  }

  disableSaveBtn() {
    if(!this.addLicenseForm.valid) 
      return true; 
    if(!this.addLicenseForm.touched && this.addLicenseForm.pristine)  
      return true;
    return false;
  }

  saveData() {
    //check if user already exists
    this.emailForAdd = this.addLicenseForm.get('email');
    let userExists = this.checkForDuplicateEmail(this.emailForAdd);
    if(!userExists) {
      this.needsUpdate = false;
      let updFields :any = {};
      this.findUpdatedFields(this.addLicenseForm, updFields, this.initialAddFormValues, true);
      this.msgText = '';
      if(this.needsUpdate) {
        let request: Partial<LicenseData> = {};
        Object.assign(request, updFields);
        const data: LicenseData = {
          firstName: request.firstName + '',
          lastName: request.lastName + '',
          email: request.email + '',
          accessType: "AccessOnly",
          customerNumber: this.userService.profile.customerNumber,
          agreementId: this.agreementId 
        }
        this.adminService.addLicenseData(data).subscribe({
          next: (res: ResultResponse)=> {
            if(res !== null && res.Data !== null && res.Data.toLowerCase().includes("success")) {
              this.reloadData();
              //window.location.reload();
              this.alertService.displaySuccess("Successfully added license");
              /* update table
              this.licenseList.insert(this.licenseList.length, this.addLicenseForm)
              this.dataSource = new MatTableDataSource((this.licenseList as FormArray).controls);
              this.changeDetectorRefs.detectChanges();
              this.dataSource.paginator = this.paginator; 
              */
            } else {
              let msg:string = "";
              if (res !== null) msg = res.ErrorMessage;
              this.alertService.displayError("Error occured while adding license. " + msg);
            }  
          }, error: err => {
            this.alertService.displayError("Error occured while adding license. " + err.error.ErrorMessage);
          } 
        }); 
      }
    }
    this.addLicenseeDialogRef.close();
  }

  cancelAdd() {
    this.addLicenseeDialogRef.close();
  }

  refreshLicenseForm(data: LicenseData[]) {
    this.licenseForm.patchValue({
      licenseList : this.formBuilder.array(data.map(
        lic => this.formBuilder.group({
        firstName: lic.firstName,
        lastName: lic.lastName,
        email: lic.email
      })))
    })
  }

  userExists(email:string): boolean {
    let exists = false;
    this.licenseDataList.forEach( function(element) { if(element.email === email) exists = true; });      
    return exists;
  }

  userWithIdExists(id:number): boolean {
    let exists = false;
    this.licenseDataList.forEach( function(element) { if(element.id === id) exists = true; });      
    return exists;
  }  
  
  getDeletedIds(email: string): number[] {
    const user = this.licenseDataList.filter(element => element.email === email);      
    return (user[0].id !== null && typeof user[0].id !== 'undefined') ? [user[0].id] : [];
  } 

  reloadData() {
    this.licenseDataList.length = 0;
    this.licenseList.clear();
    this.sharedDataService.setSubscriptions(null);
    this.retrieveDetails();
  }
}
